import { render, staticRenderFns } from "./CreateSppdModal.vue?vue&type=template&id=3e54019d&"
import script from "./CreateSppdModal.vue?vue&type=script&lang=js&"
export * from "./CreateSppdModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateSppdModal.vue?vue&type=style&index=0&id=3e54019d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports